import React, { useState } from 'react';
import clsx from 'clsx';

import './AppDownloadSwitcher.scss';
import LifestackMobileIOSQR from '../../assets/onboarding/lifestack-mobile-ios-qr.png';
import LifestackMobileAndroidQR from '../../assets/onboarding/lifestack-mobile-android-qr.png';
import { isDesktopApp } from '../../utils';

type AppType = 'ios' | 'android' | 'mac';

const MAC_APP_DOWNLOAD_URL =
  'https://storage.googleapis.com/lifestack-desktop-releases/desktop/mac/latest.dmg';

const AppDownloadSwitcher: React.FC = () => {
  const [type, setType] = useState<AppType>('ios');
  const shouldShowMacTab = !isDesktopApp();

  const clickAppType = (appType: AppType) => {
    setType(appType);
  };

  const handleDownloadMacApp = () => {
    const shouldDownload = window.confirm('Download the Lifestack Mac app?');

    if (shouldDownload) {
      window.location.assign(MAC_APP_DOWNLOAD_URL);
    }
  };

  return (
    <div className="app-download-switcher">
      {type === 'mac' ? (
        <div className="app-download-switcher__mac">
          <p className="app-download-switcher__mac__description">
            Download the Lifestack desktop app for Mac.
          </p>
          <button
            type="button"
            className="app-download-switcher__mac__download-button"
            onClick={handleDownloadMacApp}
          >
            Download Mac App
          </button>
        </div>
      ) : (
        <img
          src={type === 'ios' ? LifestackMobileIOSQR : LifestackMobileAndroidQR}
          alt="lifestack logo"
          className="app-download-switcher__image"
        />
      )}
      <div className="app-download-switcher__button-group">
        <div
          className={clsx(
            'app-download-switcher__button-group__button',
            type === 'ios' && 'app-download-switcher__button-group__button--active'
          )}
          onClick={() => clickAppType('ios')}
        >
          iOS
        </div>
        <div
          className={clsx(
            'app-download-switcher__button-group__button',
            type === 'android' && 'app-download-switcher__button-group__button--active'
          )}
          onClick={() => clickAppType('android')}
        >
          Android
        </div>
        {shouldShowMacTab && (
          <div
            className={clsx(
              'app-download-switcher__button-group__button',
              type === 'mac' && 'app-download-switcher__button-group__button--active'
            )}
            onClick={() => clickAppType('mac')}
          >
            Mac
          </div>
        )}
      </div>
    </div>
  );
};

export default AppDownloadSwitcher;
